module.exports = __webpack_public_path__ + "static/media/logo.5ffa559b.svg";